import { render, staticRenderFns } from "./language-switcher-sidebar.vue?vue&type=template&id=234c65dc"
import script from "./language-switcher-sidebar.vue?vue&type=script&lang=js"
export * from "./language-switcher-sidebar.vue?vue&type=script&lang=js"
import style0 from "./language-switcher-sidebar.vue?vue&type=style&index=0&id=234c65dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports